import React from 'react';
import { Stack, TextField, Button } from '@mui/material';
import { AppCard } from '@/components/app-card/app-card';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import { SystemData } from '../../calculations';
import {
  getSavedBudgetValue,
  getSavedBudgetCurrency,
} from '../../calculations';
import { UserDto } from '@cloudcost/shared-types/users';

interface SystemBudgetDetailsProps {
  system: SystemData | undefined;
  onRequestBudgetChange?: (system: SystemData) => void;
  onDisputeSystemCost?: (system: SystemData) => void;
  users?: UserDto[];
}

export const SystemBudgetDetails: React.FC<SystemBudgetDetailsProps> = ({
  system,
  onRequestBudgetChange,
  onDisputeSystemCost,
  users = [],
}) => {
  const getSystemOwnerDisplay = () => {
    if (!system || !system.owner_id) {
      return 'N/A';
    }
    const owner = users.find((u) => u.id === system.owner_id);
    if (!owner) {
      return 'N/A';
    }
    return `${owner.firstName} ${owner.lastName} (${owner.username})`;
  };

  return (
    <AppCard
      className="card100"
      title="System Budget"
      icon={<BarChartOutlinedIcon color="primary" />}>
      <Stack spacing={2}>
        <Stack spacing={2} direction="row">
          <TextField
            label="System Name"
            variant="outlined"
            disabled
            size="small"
            value={system ? system.name : 'No system selected'}
          />
          <TextField
            label="System Owner"
            variant="outlined"
            disabled
            size="small"
            value={getSystemOwnerDisplay()}
          />
        </Stack>
        <Stack spacing={2} direction="row">
          <TextField
            label="Annual System Budget"
            variant="outlined"
            disabled
            size="small"
            value={system ? getSavedBudgetValue(system) : 'No system selected'}
          />

          <TextField
            label="Budget Currency"
            variant="outlined"
            disabled
            size="small"
            value={system ? getSavedBudgetCurrency(system) : 'N/A'}
          />

          {system && getSavedBudgetValue(system) !== 'No budget set' && (
            <>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => onRequestBudgetChange?.(system)}>
                Request System Budget Change
              </Button>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                onClick={() => onDisputeSystemCost?.(system)}>
                Dispute system cost
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </AppCard>
  );
};
